import { Injectable } from '@angular/core';

interface AppSettings {
  bookkeepingStartDate?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AppSettingsService {
  private readonly storageKey = 'appSettings';
  private readonly defaults: AppSettings = {
    bookkeepingStartDate: '2020-07-01'
  };

  getSettings(): AppSettings {
    const stored = localStorage.getItem(this.storageKey);

    if (!stored) {
      return { ...this.defaults };
    }

    return {
      ...this.defaults,
      ...JSON.parse(stored)
    };
  }

  updateSettings(settings: Partial<AppSettings>) {
    const next = {
      ...this.getSettings(),
      ...settings
    };

    localStorage.setItem(this.storageKey, JSON.stringify(next));
  }

  getBookkeepingStartDate() {
    return this.getSettings().bookkeepingStartDate || '';
  }

  setBookkeepingStartDate(date: string) {
    this.updateSettings({ bookkeepingStartDate: date });
  }
}
